import { HouseDTO, HousesDTO } from '../../shared/DTO/HouseDTO';
import { PERMISSION_ROLE, HOUSE_PROFILE, HOUSE_STATUS } from './houses.constants';

export class House {
    address: string;
    houseId: string;
    permissionRole: PERMISSION_ROLE;
    name: string;
    houseProfile: HOUSE_PROFILE;
    classification: string;
    postalCode: string;
    city: string;
    district: string;
    country: string;
    timezone: string;
    serviceProvider: string;
    status: string;
    electricityLocalId: string;
    gasLocalId: string;
    constructor(
      city: string,
      district: string,
      country: string,
      postalCode: string,
      address: string,
      houseId: string,
      permissionRole: PERMISSION_ROLE,
      name: string,
      houseProfile: HOUSE_PROFILE,
      classification: string,
      timezone?: string,
      serviceProvider?: string,
      status?: HOUSE_STATUS,
      electricityLocalId?: string,
      gasLocalId?: string,
    ) {
      this.city = city;
      this.district = district;
      this.country = country;
      this.postalCode = postalCode;
      this.address = address;
      this.houseId = houseId;
      this.permissionRole = permissionRole;
      this.name = name;
      this.houseProfile = houseProfile;
      this.classification = classification;
      this.timezone = timezone ? timezone : null;
      this.serviceProvider = serviceProvider ? serviceProvider : null;
      this.status = status ? status : null;
      this.electricityLocalId = electricityLocalId ? electricityLocalId : null;
      this.gasLocalId = gasLocalId ? gasLocalId : null;
    }

    static fromDTO(dto: HousesDTO): Array<House> {
        const houseArray: Array<House> = new Array<House>();
        if (dto.houses) {
          dto.houses.forEach(house => {
            houseArray.push(
              new House(
                house.city,
                house.district,
                house.country,
                house.postalCode,
                house.address,
                house.houseId,
                <PERMISSION_ROLE>house.permissionRole,
                house.name,
                <HOUSE_PROFILE>house.houseProfile,
                house.classification,
                house.timezone,
                house.serviceProvider,
                <HOUSE_STATUS>house.status,
                house.electricityLocalId,
                house.gasLocalId,
              ),
            );
          });
        }
        return houseArray;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/houses/houses.model.ts